import { Controller } from "@hotwired/stimulus"

// Drag-and-drop file picker: drop or click either way land the file on the
// same hidden <input type=file>, so the surrounding form submits normally —
// no XHR here, this controller only handles the picking UI.
export default class extends Controller {
  static targets = ["area", "input", "label"]

  browse() {
    this.inputTarget.click()
  }

  dragover(event) {
    event.preventDefault()
    this.areaTarget.classList.add("border-primary")
  }

  dragleave() {
    this.areaTarget.classList.remove("border-primary")
  }

  drop(event) {
    event.preventDefault()
    this.areaTarget.classList.remove("border-primary")
    this.inputTarget.files = event.dataTransfer.files
    this.#updateLabel()
  }

  selected() {
    this.#updateLabel()
  }

  #updateLabel() {
    const file = this.inputTarget.files[0]
    if (file) this.labelTarget.textContent = file.name
  }
}
